/**
 * Workers Compensation Guards
 *
 * Guards that check if the visit is workers comp related.
 */

import type { GuardWithMetadata } from "./sms.guard";

/**
 * Is Workers Comp Guard
 *
 * Checks if the patient answered "Yes" to workers comp question.
 * This determines if they follow the workers comp flow vs regular flow.
 *
 * NOTE: Guards run BEFORE actions, so we check event.data (not context)
 * NOTE: No need for isNotWorkersComp - use fallback transition instead
 */
export const isWorkersComp: GuardWithMetadata = {
  // biome-ignore lint/suspicious/noExplicitAny: XState guard params are complex
  impl: ({ context, event }: { context: any; event: any }) => {
    console.log("isWorkersComp guard check");
    // Check event.data first (guards run before actions)
    if (event.data && typeof event.data.isWorkersComp === "boolean") {
      return event.data.isWorkersComp === true;
    }

    // Fallback to context (for state restoration)
    return context.isWorkersComp === true;
  },
  metadata: {
    displayName: "isWorkersComp",
    description: "Patient answered YES to workers comp question",
    requiresContext: ["isWorkersComp"],
    category: "context",
  },
};
